<template>
    <div>
        <div class="row">
            <div class="col-sm-4" v-if="isCompanyContact">
                <div class="form-group">
                    <label for="clients-add-position{{ idSuffix }}">
                        Identifiant
                    </label>
                    <input type="text"
                           v-model="data.position"
                           placeholder="Inconnue"
                           required
                           class="form-control"
                           id="clients-add-position{{ idSuffix }}">
                </div>
            </div>
        </div>
        <div class="row radio">
            <div class="col-sm-4">
                <label for="clients-add-title-mademoiselle{{ idSuffix }}">
                    <input type="radio"
                           name="clients-add-title{{ idSuffix }}"
                           v-model="data.title"
                           value="mademoiselle"
                           id="clients-add-title-mademoiselle{{ idSuffix }}">
                    Mademoiselle
                </label>
            </div>
            <div class="col-sm-4">
                <label for="clients-add-title-madame{{ idSuffix }}">
                    <input type="radio"
                           name="clients-add-title{{ idSuffix }}"
                           v-model="data.title"
                           value="madame"
                           id="clients-add-title-madame{{ idSuffix }}">
                    Madame
                </label>
            </div>
            <div class="col-sm-4">
                <label for="clients-add-title-monsieur{{ idSuffix }}">
                    <input type="radio"
                           name="clients-add-title{{ idSuffix }}"
                           v-model="data.title"
                           value="monsieur"
                           id="clients-add-title-monsieur{{ idSuffix }}">
                    Monsieur
                </label>
            </div>
        </div>
        <div class="row">
            <div :class="'col-sm-' + (isCompanyContact ? '6' : '4')">
                <div class="form-group">
                    <label for="clients-add-last-name{{ idSuffix }}">Nom</label>
                    <input type="text"
                           v-model="data.last_name"
                           required
                           class="form-control"
                           id="clients-add-last-name{{ idSuffix }}">
                </div>
            </div>
            <div :class="'col-sm-' + (isCompanyContact ? '6' : '4')">
                <div class="form-group">
                    <label for="clients-add-first-name{{ idSuffix }}">Prénom</label>
                    <input type="text"
                           v-model="data.first_name"
                           required
                           class="form-control"
                           id="clients-add-first-name{{ idSuffix }}">
                </div>
            </div>
            <div class="col-sm-4" v-if="!isCompanyContact">
                <div class="form-group">
                    <label>
                        Naissance
                    </label>

                    <div class="form-control">
                        <editable-date :value.sync="data.birth_date"
                                       placeholder="Inconnue"
                                       :enable-reset="true"></editable-date>
                    </div>
                </div>
            </div>
        </div>

        <div v-for="(idx, info) in data.info"
             class="form-group">
            <label for="clients-info-{{ idSuffix }}-{{ idx }}">
                {{ labelForInfo(info.type) }}
            </label>

            <div class="row">
                <div class="col-sm-3">
                    <input v-model="info.label"
                           class="form-control"
                           id="clients-info{{ idSuffix }}-{{ idx }}-label">
                </div>
                <div class="col-sm-9"
                     v-if="info.type === 'email'">
                    <input type="email"
                           v-model="info.value"
                           class="form-control"
                           id="clients-info{{ idSuffix }}-{{ idx }}">
                </div>
                <div class="col-sm-9"
                     v-if="info.type === 'phone'">
                    <input-phone :phone-number.sync="info.value"
                                 :valid.sync="info.valid"
                                 class="form-control"
                                 id="clients-info{{ idSuffix }}-{{ idx }}"></input-phone>
                </div>
                <div
                    class="col-sm-9"
                    v-if="info.type === 'address' && !isCompanyContact">
                    <input-address :input-class="'form-control'"
                                   :input-id="'clients-info' + idSuffix + '-' + idx"
                                   placeholder="Saisir puis choisir une adresse"
                                   :valid.sync="info.valid"
                                   :address.sync="info.value"></input-address>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 f -j-center -gutter-small">
                <button class="btn btn-default"
                        id="clients-info{{ idSuffix }}-add-email"
                        @click.prevent="addInfo('email')">
                    <i class="fa fa-plus"></i>
                    Email
                </button>
                <button class="btn btn-default"
                        id="clients-info{{ idSuffix }}-add-phone"
                        @click.prevent="addInfo('phone')">
                    <i class="fa fa-plus"></i>
                    Tél
                </button>
                <button class="btn btn-default" v-if="!isCompanyContact"
                        id="clients-info{{ idSuffix }}-add-address"
                        @click.prevent="addInfo('address')">
                    <i class="fa fa-plus"></i>
                    Adresse
                </button>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import InputPhone from '../form/InputPhone';
    import InputAddress from '../form/InputAddress';
    import EditableDate from '../editable/EditableDate';
    import {makeDefaultInfo} from './utils';

    export default {
        components: {
            EditableDate,
            InputPhone,
            InputAddress
        },
        props: {
            data: {
                'default': {
                    title: 'mademoiselle',
                    last_name: '',
                    first_name: '',
                    position: '',
                    info: []
                },
                twoWay: true
            },
            idSuffix: {
                'default': ''
            },
            valid: {
                'default': false,
                twoWay: true
            },
            isCompanyContact: {
                'default': false,
                type: Boolean
            }
        },
        data() {
            return {
                phoneValid: false,
                addressValid: false
            };
        },
        computed: {
            isValid() {
                if (this.isCompanyContact && !this.data.position) {
                    return false;
                }
                if (!this.data.first_name || !this.data.last_name) {
                    return false;
                }

                return !this.data.info.some((info) => {
                    if (info.type === 'email') {
                        return !this.emailValid(info.value);
                    }

                    return !info.valid;
                });
            }
        },
        methods: {
            /**
             * Check the validity of an email address
             */
            emailValid(email) {
                return !email || email.indexOf('@') >= 0;
            },

            /**
             * Append an info to the list of info
             */
            addInfo(type) {
                this.data.info.push(makeDefaultInfo(type));
            },

            /**
             * Generates the label for any given info type
             */
            labelForInfo(type) {
                return ({
                    'email': 'Email',
                    'phone': 'Téléphone',
                    'address': 'Adresse'
                })[type];
            }
        },
        watch: {
            isValid() {
                this.valid = this.isValid;
            }
        },
        ready() {
            this.valid = this.isValid;
        }
    };
</script>



// WEBPACK FOOTER //
// PersonForm.vue?54fea5d6